<script>
// Font awesome
import { library } from "./.node_modules/@fontawesome/fontawesome-svg-core";
import { fas } from "./.node_modules/@fontawesome/free-solid-svg-icons";
import { far } from "./.node_modules/@fontawesome/free-regular-svg-icons";
import { fab } from "./.node_modules/@fontawesome/free-brands-svg-icons";
import {
  FontAwesomeIcon, 
  FontAwesomeLayers,
  FontAwesomeLayersText, 
} from "./.node_modules/@fontawesome/vue-fontawesome";

// Figma
import figmas from "./figma/*.svg";

import { declareVueComponent } from "/vodalys/vvuejs";

library.add(fas, far, fab);
declareVueComponent("FontAwesomeIcon", FontAwesomeIcon);
declareVueComponent("FontAwesomeLayers", FontAwesomeLayers);
declareVueComponent("FontAwesomeLayersText", FontAwesomeLayersText);

export default {
  props: {
    icon: String,
    inline: Boolean,
    spin: Boolean,
  },
  data() {
    return {
      figmas,
    };
  },
  methods: {
    fa6: function (icon) {
      let splittedIcon = icon.split(" ");

      if (splittedIcon.length == 1) {
        return icon.substr(4);
      } else {
        return icon.split(" ").map((e) => {
          return e.substr(4);
        });
      }
    },
  },
};
</script>

<template>
  <div
    class="f-icon"
    v-if="icon"
    :class="{ inline: inline }"
    @click="$emit('click')"
  >
    <img v-if="icon.startsWith('fg-')" :src="figmas[icon.substr(3)]" />
    <font-awesome-icon
      :spin="spin"
      v-if="icon.startsWith('fa6-')"
      :icon="fa6(icon)"
    ></font-awesome-icon>
    <i v-if="icon.startsWith('fa-')" class="fa" :class="icon"></i>
  </div>
</template>

<style lang="scss">
.f-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  $sizes: (16, 24, 32);

  @each $size in $sizes {
    &.s#{$size} {
      width: #{$size}px;
      height: #{$size}px;
      > svg {
        width: 90%;
        height: 90%;
      }
    }
  }

  img {
    height: 100%;
    width: 100%;
  }

  .inline {
    display: inline-flex;
  }
}
</style>